import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import store from './store';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from 'styled-components';
import theme from './theme/theme';
import './utils/globalErrorHandlers'; // Import global error handlers

ReactDOM.render(
  <React.StrictMode>
     <ThemeProvider theme={theme}>
    <Provider store={store}>
      <Suspense fallback={<div className="loading" />}>
        <App />
      </Suspense>
    </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
